module.exports = __webpack_public_path__ + "static/media/home-bg-11.0b43e7c1.jpg";